export default __webpack_public_path__ + "static/media/divider-gray.3e95e179.svg";